import { render, staticRenderFns } from "./bigBorder.vue?vue&type=template&id=760a1fd0&scoped=true"
import script from "./bigBorder.vue?vue&type=script&lang=js"
export * from "./bigBorder.vue?vue&type=script&lang=js"
import style0 from "./bigBorder.vue?vue&type=style&index=0&id=760a1fd0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760a1fd0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\yl\\yl-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('760a1fd0')) {
      api.createRecord('760a1fd0', component.options)
    } else {
      api.reload('760a1fd0', component.options)
    }
    module.hot.accept("./bigBorder.vue?vue&type=template&id=760a1fd0&scoped=true", function () {
      api.rerender('760a1fd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bigScreen/components/bigBorder.vue"
export default component.exports